import { useState } from "react";
import { IconSearch, IconArrowRight } from "@tabler/icons-react";
import styles from "./BankAdd.module.css";
import { useModal } from "../../hooks/use-modal.jsx";
import useDebouncedValue from "../../hooks/use-debounced-value";
import useNordigen from "../../hooks/use-nordigen";
import useLoader from "../../hooks/use-loader";
import Button from "../UI/Button";

export default function BankAdd() {
  const { institutions, selectInstitution } = useNordigen();
  const [isSelecting, selectInstitutionLoader] = useLoader(selectInstitution);
  const [filter, setFilter] = useState("");
  const debouncedFilter = useDebouncedValue(filter, 200);

  const filteredInstitutions = institutions.filter((institution) =>
    institution.name.toLowerCase().includes(debouncedFilter),
  );

  const [Modal] = useModal(true);

  return (
    <Modal>
      <div className={styles.inputGroup}>
        <IconSearch size={20} />
        <input
          type="text"
          name="filtre"
          className={styles.inputSearch}
          placeholder="Filtrer"
          onChange={(e) => setFilter(e.target.value.toLowerCase())}
        />
      </div>
      <br />
      <div className={styles.buttonGroup}>
        {filteredInstitutions.length > 0 ? (
          filteredInstitutions.map((institution) => (
            <Button
              key={institution.id}
              type="button"
              variant="secondary"
              isLoading={isSelecting}
              onClick={() => selectInstitutionLoader(institution.id)}
              className={styles.buttonBank}
            >
              <img src={institution.logo} alt={institution.name} width={20} />
              {institution.name}
              <IconArrowRight size={16} />
            </Button>
          ))
        ) : (
          <span>Aucune banque trouvée</span>
        )}
      </div>
    </Modal>
  );
}
